<app-dialog-header [title]="'Add Time Off'"></app-dialog-header>

<mat-divider class="divider"></mat-divider>

<div mat-dialog-content class="create-time-off-container">
    <form [formGroup]="timeOffForm">
        <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input
                [formGroup]="timeOffForm"
                [rangePicker]="picker"
            >
                <input
                    matStartDate
                    formControlName="startDate"
                    placeholder="Start Date"
                />
                <input
                    matEndDate
                    formControlName="endDate"
                    placeholder="End Date"
                />
            </mat-date-range-input>

            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>

            <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
            ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-form-field appearance="outline" class="tw-w-full tw-mt-2">
            <mat-label>Title</mat-label>
            <input
                matInput
                formControlName="timeOffTitle"
                placeholder="Title"
                maxlength="60"
            />
        </mat-form-field>

        <mat-form-field class="tw-w-full mat-form-field-time-pointer" appearance="outline" (click)="openStartTime()">
            <mat-label>Start time</mat-label>
            <input matInput #startTimeInput  formControlName="startTimeDisplay" type="text" class="input-time-pointer" readonly />
        </mat-form-field>

        <mat-form-field class="tw-w-full mat-form-field-time-pointer" appearance="outline" (click)="openEndTime()">
            <mat-label>End time</mat-label>
            <input matInput #endTimeInput formControlName="endTimeDisplay" type="text" class="input-time-pointer" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label>Reason For Time Off*</mat-label>
            <mat-select formControlName="timeOffType">
                <mat-option value="" disabled selected>Choose One</mat-option>
                <mat-option value="Vacation">Vacation</mat-option>
                <mat-option value="Personal">Personal</mat-option>
                <mat-option value="Sick">Sick</mat-option>
                <mat-option value="Other">Other</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label>Description</mat-label>
            <input
                matInput
                formControlName="timeOffDescription"
                placeholder="Description"
            />
        </mat-form-field>
    </form>
</div>

<div class="tw-flex tw-justify-between tw-items-center tw-w-full">
    <button
        mat-button
        class="tw-w-[40%] tw-flex tw-m-3 tw-self-end m3-error"
        (click)="closeDialog()"
    >
        Cancel
    </button>

    <button
        mat-button
        class="tw-w-[40%] tw-flex tw-m-3 tw-self-end"
        [disabled]="disableButtonForInvalidTimes()"
        (click)="saveTimeOff()"
    >
        Add Time Off
    </button>
</div>
